"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var categoryApi = _interopRequireWildcard(require("@/api/categoryApi.js"));
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
var _default = exports.default = {
  // name: "info"
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      ddd: [{
        label: '一级 1',
        children: [{
          label: '二级 1-1',
          children: [{
            label: '三级 1-1-1'
          }]
        }]
      }, {
        label: '一级 2',
        children: [{
          label: '二级 2-1',
          children: [{
            label: '三级 2-1-1'
          }]
        }, {
          label: '二级 2-2',
          children: [{
            label: '三级 2-2-1'
          }]
        }]
      }, {
        label: '一级 3',
        children: [{
          label: '二级 3-1',
          children: [{
            label: '三级 3-1-1'
          }]
        }, {
          label: '二级 3-2',
          children: [{
            label: '三级 3-2-1'
          }]
        }]
      }],
      dataList: {
        // 数据结果
        page: 0,
        limit: 0,
        totalPage: 0,
        total: 0,
        list: []
      }
    };
  },
  mounted: function mounted() {
    this.handlerGetTreeList(this.id);
  },
  methods: {
    handlerGetTreeList: function handlerGetTreeList(id) {
      var _this = this;
      if (!id) {
        this.$message.error('当前数据id不正确');
        return;
      }
      categoryApi.treeCategroy({
        pid: id
      }).then(function (data) {
        _this.dataList = data;
      });
    },
    handleNodeClick: function handleNodeClick(data) {
      console.log('data:', data);
    }
  }
};